import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("stc_token");
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On any 401, send the user to /login preserving where they came from so
// they can return to the offer / agreement / dashboard after signing in.
// Skip redirect on client-portal pages (they have their own auth flow).
http.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const path = (typeof window !== "undefined" && window.location?.pathname) || "/";
    const onLogin = path.startsWith("/login");
    const onClientPortal = path.startsWith("/client-portal");
    if (status === 401 && !onLogin && !onClientPortal) {
      const next = encodeURIComponent(path + (window.location.search || ""));
      window.location.assign(`/login?next=${next}`);
    }
    return Promise.reject(error);
  }
);

/** Resolve image URLs that come from backend as relative `/api/images/{id}` */
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
